import React from 'react';
import { Table } from 'semantic-ui-react';

import { SprayEventWeather } from 'services/sprayEvents/types';
import { useSelector } from 'react-redux';

import DateTableHeaderCell from '../DateTableHeaderCell';
import AreaTableHeaderCell from '../AreaTableHeaderCell';
import SelectableTableHeaderCell from '../SelectableTableHeaderCell';
import { selectWeatherFields } from './selectors';
import ApplyAllFormSpy from '../ApplyAllFormSpy';

const WeatherTableHeader = (): React.ReactElement => {
    const fields = useSelector(selectWeatherFields);

    return (
        <Table.Header className="complete-spray-event-form-table-header">
            <Table.Row>
                <ApplyAllFormSpy
                    fields={fields}
                    applyAllFieldName="weatherApplyAll"
                />
                <DateTableHeaderCell />
                <AreaTableHeaderCell />
                <SelectableTableHeaderCell
                    name="weatherApplyAll"
                    value={SprayEventWeather.CALM}
                    title="Calm"
                    fields={fields}
                    defaultValue={SprayEventWeather.CALM}
                />
                <SelectableTableHeaderCell
                    name="weatherApplyAll"
                    value={SprayEventWeather.BREEZY}
                    title="Breezy"
                    fields={fields}
                />

                <SelectableTableHeaderCell
                    name="weatherApplyAll"
                    value={SprayEventWeather.WINDY}
                    title="Windy"
                    fields={fields}
                />
                <SelectableTableHeaderCell
                    name="weatherApplyAll"
                    value={SprayEventWeather.DRY}
                    title="Dry"
                    fields={fields}
                />
                <SelectableTableHeaderCell
                    name="weatherApplyAll"
                    value={SprayEventWeather.SHOWERY}
                    title="Showery"
                    fields={fields}
                />
                <SelectableTableHeaderCell
                    name="weatherApplyAll"
                    value={SprayEventWeather.RAIN}
                    title="Rain"
                    fields={fields}
                />
            </Table.Row>
        </Table.Header>
    );
};

export default WeatherTableHeader;
